<!-- eslint-disable vue/no-v-html -->
<template>
  <section
    class="prose prose-richtext mt-4 max-w-none first:mt-0 md:mt-12"
    v-html="block.content.text"
    @click.prevent="onSeoTextClick"
  ></section>
</template>

<script setup lang="ts">
defineProps<{ block: { content: TextBlockContent } }>()

const { handleClick } = useSeoText()

function onSeoTextClick(event: MouseEvent) {
  handleClick(event, { scrollBehavior: 'smooth' })
}
</script>
